module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-66.3384ebad.svg";